<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">new importer</small>
      </legend>
      <div>
        <form @submit.prevent="newImporter()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Importer name</label>
                <input
                  type="text"
                  class="form-control importer_name"
                  placeholder="importer name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Mobile number</label>
                <input
                  type="number"
                  class="form-control mobile_number"
                  placeholder="mobile number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Marketer name</label>
                <input
                  type="text"
                  class="form-control marketer_name"
                  placeholder="marketer name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Country</label>
                <input type="text" class="form-control country" placeholder="country" required />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email address</label>
                <input
                  type="email"
                  class="form-control email_address"
                  placeholder="email address"
                  required
                />
              </div>
              <div class="form-group">
                <label>Address</label>
                <input type="text" class="form-control address" placeholder="address" required />
              </div>
              <div class="form-group">
                <label>City</label>
                <input type="text" class="form-control city" placeholder="city" required />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingImporter btn-rounded">
            <i class="fa fa-user"></i> create importer
          </button>
          <button type="button" class="btn btn-primary btn-flat creatingImporterLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import $ from 'jquery'
export default {
    created() {

    },
    methods: {
        ...mapActions(["newImporter"])
    }
}
</script>
<style scoped>
.creatingImporterLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/importers/importer.vue